import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31dd0efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "newsletter-success"
}
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "newsletter-block-input-container" }
const _hoisted_4 = { class: "newsletter-block-submit outline-btn" }
const _hoisted_5 = {
  key: 0,
  class: "newsletter-block-error"
}

import { mailService } from '@/services';
import { logInteractionEvent } from '@/utils/analytics';
import { NewsletterBlock } from '@functions/model/content';
import { PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterBlock',
  props: {
  block: {
    type: Object as PropType<NewsletterBlock>,
    required: true
  },
  pageType: {
    type: String,
    required: true
  },
  center: {
    type: Boolean
  }
},
  setup(__props) {

const props = __props;



const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const email = ref('');
const hasInternalError = ref(false);
const hasValidationError = ref(false);
const success = ref(false);

async function submit() {
  hasInternalError.value = false;
  hasValidationError.value = !email.value || !email.value.match(EMAIL_REGEX);

  if (hasValidationError.value) {
    return;
  }

  try {
    logInteractionEvent({
      page_type: props.pageType,
      event_name: 'subscribe_newsletter'
    });

    const response = await mailService.subscribe(email.value);

    if (!response.ok) {
      hasInternalError.value = true;
      return;
    }

    success.value = true;
  } catch (e) {
    console.error('Failed to subscribe to newsletter', e);
    hasInternalError.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["newsletter-block-container", { center: __props.center }])
  }, [
    _createVNode(_Transition, {
      name: "quick-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (success.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.block.successText), 1))
          : (_openBlock(), _createElementBlock("form", {
              key: 1,
              class: "newsletter-block",
              onSubmit: _withModifiers(submit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  class: "newsletter-block-input",
                  placeholder: "e-mailadres",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
                }, null, 512), [
                  [_vModelText, email.value]
                ]),
                _createElementVNode("button", _hoisted_4, _toDisplayString(__props.block.submitText), 1)
              ]),
              (hasValidationError.value || hasInternalError.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(hasValidationError.value ? 'Vul een geldig e-mailadres in.' : 'Er is iets misgegaan. Probeer het opnieuw.'), 1))
                : _createCommentVNode("", true)
            ], 40, _hoisted_2))
      ]),
      _: 1
    })
  ], 2))
}
}

})